import { AppEndpoints } from '../app.endpoints';
import { HttpService } from '../../globals/providers/http.service';
import { Observable } from 'rxjs/Observable';
import {
	IEmptyRequest,
	ITwoFactorAutheticationRequest,
} from '../classes/http-requests';
import { IVerificationCodeInfo } from '../classes/http-responses';

export class TwofaService {
	public static login(userId: string, password: string, rememberDevice: boolean): Observable<void> {
		const request: ITwoFactorAutheticationRequest = {
			userID: userId,
            password: password,
            rememberDevice: rememberDevice
		};

		return HttpService.post(AppEndpoints.twofaLogin, request);
	}

	public static resendOtp(userId: string): Observable<IVerificationCodeInfo> {
		const request: IEmptyRequest = {
			userID: userId,
		};
		return HttpService.post<IVerificationCodeInfo>(AppEndpoints.twofaResendOtp, request);
	}
}
